import { render, staticRenderFns } from "./WarehouseForm.vue?vue&type=template&id=0fb1b3bf"
import script from "./WarehouseForm.vue?vue&type=script&lang=js"
export * from "./WarehouseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports